import { render } from "./LoadingVue.vue?vue&type=template&id=48ac84a6&scoped=true"
import script from "./LoadingVue.vue?vue&type=script&lang=js"
export * from "./LoadingVue.vue?vue&type=script&lang=js"

import "./LoadingVue.vue?vue&type=style&index=0&id=48ac84a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ac84a6"]])

export default __exports__